/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import clamp from "clamp-js";
import LazyLoadImg from "../utils/lazyLoadImg";
import { sendDataLayerEvent } from "@demant/product-experience-page/lib/visual-oticon/configuration/utils";
import convertEntities from "../utils/convertEntities";
var Card = function Card(_ref) {
  var data = _ref.data,
    className = _ref.className,
    dictionary = _ref.dictionary,
    isSelected = _ref.isSelected,
    selectedId = _ref.selectedId,
    areSelected = _ref.areSelected,
    type = _ref.type;
  useEffect(function () {
    var cgCardDescription = document.querySelectorAll(".cg__card__description");
    if (cgCardDescription) {
      cgCardDescription.forEach(function (description) {
        if (description.offsetHeight === 76) {
          description.style.paddingBottom = "".concat(19, "px");
        }
        clamp(description, {
          clamp: 5
        });
      });
    }
  }, []);
  var cgCardContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cg__card__top"
  }, data.compatible === true && !selectedId || data.compatible === true && areSelected ? /*#__PURE__*/React.createElement("div", {
    className: "cg__card__top__info cg__card__top__info--badge"
  }, dictionary.compatible) : "", data.compatible === false && /*#__PURE__*/React.createElement("div", {
    className: "cg__card__top__info cg__card__top__info--badge-incompatible"
  }, dictionary.incompatible), data.telVsBlue && isSelected === true ? /*#__PURE__*/React.createElement("div", {
    className: "cg__card__top__info"
  }, dictionary.telVsBlue) : "", data.directStreaming === false && /*#__PURE__*/React.createElement("div", {
    className: "cg__card__top__info noDirectStreaming"
  }, "".concat(dictionary.noDirectStreaming)), data.minimumSoftwareVersion && data.isIOSDevice && /*#__PURE__*/React.createElement("div", {
    className: "cg__card__top__info ios"
  }, "".concat(dictionary.requireIos, " ").concat(data.minimumSoftwareVersion, " ").concat(dictionary.later)), data.minimumSoftwareVersion && !data.isIOSDevice && /*#__PURE__*/React.createElement("div", {
    className: "cg__card__top__info android"
  }, "".concat(dictionary.requireAndroid, " ").concat(data.minimumSoftwareVersion, " ").concat(dictionary.later)), /*#__PURE__*/React.createElement("div", {
    className: "cg__card__spacer"
  }), data.imageLink && /*#__PURE__*/React.createElement("div", {
    className: "cg__card__image"
  }, className === "hidden" ? /*#__PURE__*/React.createElement(LazyLoadImg, {
    src: data.imageLink,
    alt: data.title
  }) : /*#__PURE__*/React.createElement("img", {
    src: data.imageLink,
    alt: data.title
  }))), /*#__PURE__*/React.createElement("div", {
    className: "cg__card__bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cg__card__title"
  }, convertEntities(data.title), "\xA0", data.subTitle ? convertEntities(data.subTitle) : ""), data.description && /*#__PURE__*/React.createElement("div", {
    className: "cg__card__description"
  }, convertEntities(data.description)), data.description && /*#__PURE__*/React.createElement("div", {
    className: "cg__card__link"
  }, /*#__PURE__*/React.createElement("div", null, dictionary.learnMore.title))));
  return /*#__PURE__*/React.createElement(React.Fragment, null, type === "devices" ? /*#__PURE__*/React.createElement("div", {
    className: "cg__card ".concat(className, " ").concat(!data.description ? "cg__card--simple" : "")
  }, cgCardContent) : /*#__PURE__*/React.createElement("a", {
    href: "".concat(dictionary.learnMore.link, "?productId=").concat(data.id, "&redirectUrl=").concat(encodeURIComponent(window.location.pathname + window.location.search)),
    onClick: function onClick(e) {
      return sendDataLayerEvent("Product card", "".concat(data.title, " ").concat(data.subTitle ? data.subTitle : ""), e);
    },
    key: data.id,
    className: "cg__card ".concat(className, " ").concat(!data.description ? "cg__card--simple" : "")
  }, cgCardContent));
};
Card.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
    title: PropTypes.string,
    description: PropTypes.string,
    imageLink: PropTypes.string,
    compatible: PropTypes.bool,
    needsIntermediary: PropTypes.bool,
    telVsBlue: PropTypes.bool,
    iosVersion: PropTypes.number,
    androidVersion: PropTypes.number,
    minimumSoftwareVersion: PropTypes.string,
    isIOSDevice: PropTypes.bool
  }).isRequired,
  className: PropTypes.string,
  dictionary: PropTypes.object.isRequired,
  selectedId: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
  isSelected: PropTypes.bool,
  areSelected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string
};
Card.defaultProps = {
  className: ""
};
export default Card;